export const useTheme = () => {
  const colorMode = useColorMode()
  const systemIsDarkMode = window?.matchMedia('(prefers-color-scheme: dark)')?.matches

  const toggleTheme = () => {
    if (colorMode.preference === 'dark') {
      colorMode.preference = 'light'
    } else {
      colorMode.preference = 'dark'
    }
  }

  const setDarkMode = () => {
    colorMode.preference = 'dark'
  }

  const setLightMode = () => {
    colorMode.preference = 'light'
  }

  const setSystemMode = () => {
    colorMode.preference = 'system'
  }

  const isDarkMode = computed(() => colorMode.preference === 'dark' || (colorMode.preference === 'system' && colorMode.value === 'dark'))

  return {
    colorMode,
    toggleTheme,
    isDarkMode,
    setDarkMode,
    setLightMode,
    setSystemMode,
    systemIsDarkMode
  }
}
